<template>
  <div>
    <el-dialog
      title="选择销售单行项目"
      :visible="show"
      width="1000px"
      @close="close"
    >
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="400px"
        v-loading="loading"
      >
        <el-table-column
          label="商品图片"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <CommodityImage
              :commodity="scope.row.commoditySnapshot"
              :commoditySpec="scope.row.commoditySpecSnapshot"
            ></CommodityImage>
          </template>
        </el-table-column>
        <el-table-column
          prop="commoditySnapshot.name"
          label="商品信息"
          min-width="150"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <span style="font-size: 1.1em">{{
                scope.row.commoditySnapshot.name
              }}</span
              ><br />
              {{ "规格：" + scope.row.commoditySpecSnapshot.specName }}<br />
              {{ "分类：" + scope.row.commoditySnapshot.commodityCategory.name
              }}<br />
              {{ "颜色：" + scope.row.commoditySnapshot.color }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityBuyingTotalAmount"
          label="总零售价"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <fm-amount
              :amount="scope.row.commodityBuyingTotalAmount"
            ></fm-amount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="成交价"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <fm-amount :amount="scope.row.itemAmount"></fm-amount>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-document"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button slot="reference" type="success" @click="confirmSelect">
          确认选择
        </el-button>
      </div> -->
    </el-dialog>

    <el-dialog
      title="选择销售单行项目"
      :visible="editItemPopupShow"
      width="600px"
      @close="editItemPopupShow = false"
      v-if="editItemPopupShow"
    >
      <el-row>
        <el-col :span="3">
          <CommodityImage
            :commodity="editItem.relatedSaleOrderItem.commoditySnapshot"
            :commoditySpec="editItem.relatedSaleOrderItem.commoditySpecSnapshot"
            size="60px"
          >
          </CommodityImage>
        </el-col>
        <el-col :span="20">
          <p>
            商品：<span style="font-weight: bold">{{
              editItem.relatedSaleOrderItem.commoditySnapshot.name
            }}</span>
          </p>
          <p>
            <span v-fmtype="''">规格：</span
            ><span v-fmtype="''" style="font-weight: bold">{{
              editItem.relatedSaleOrderItem.commoditySpecSnapshot.specName
            }}</span>
          </p>
          <p>
            <span v-fmtype="''">分类：</span
            ><span v-fmtype="''" style="font-weight: bold">{{
              editItem.relatedSaleOrderItem.commoditySnapshot.commodityCategory
                .name
            }}</span>
          </p>
          <p>
            <span v-fmtype="''">颜色：</span
            ><span v-fmtype="''" style="font-weight: bold">{{
              editItem.relatedSaleOrderItem.commoditySnapshot.color
            }}</span>
          </p>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row class="fm-flex">
        <el-col :span="12">
          <el-tooltip effect="dark" content="" placement="top-start">
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">当前库存说明</div>
              对应商品的最新库存数量
            </div>
            <i class="el-icon el-icon-question fm-mr-5"></i>
          </el-tooltip>
          <span>当前库存</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-skeleton
            animated
            :rows="1"
            v-if="!editItem.relatedSaleOrderItem.commoditySpec"
          >
            <template slot="template">
              <el-skeleton-item
                variant="rect"
                style="width: 240px; height: 80px"
              />
            </template>
          </el-skeleton>
          <div class="quantity_info" v-else>
            <div class="column">
              <div class="title">
                <div>可用库存</div>
                <div>待入库</div>
                <div>待出库</div>
                <div>报损中</div>
                <div>调拨中</div>
              </div>
              <div class="num">
                <div>
                  {{
                    editItem.relatedSaleOrderItem.commoditySpec
                      .availableQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedSaleOrderItem.commoditySpec
                      .toBeInputQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedSaleOrderItem.commoditySpec
                      .toBeOutputQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedSaleOrderItem.commoditySpec.lossingQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedSaleOrderItem.commoditySpec.transferQuantity
                  }}
                </div>
              </div>
            </div>
            <div class="column" style="margin: 0 10px 0 10px">
              <div class="num">
                <div>,</div>
                <div>,</div>
                <div>,</div>
                <div>,</div>
              </div>
            </div>
            <div class="column">
              <div class="title">
                <div>虚拟库存</div>
                <div>入库中</div>
                <div>出库中</div>
                <div>已报损</div>
              </div>
              <div class="num">
                <div>
                  {{
                    editItem.relatedSaleOrderItem.commoditySpec
                      .fictitiousQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedSaleOrderItem.commoditySpec.inputingQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedSaleOrderItem.commoditySpec
                      .outputingQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedSaleOrderItem.commoditySpec
                      .completedLossQuantity
                  }}
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row class="fm-flex">
        <el-col :span="12">
          <span>单位</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span>{{
              editItem.relatedSaleOrderItem.commoditySnapshot.unit
            }}</span>
          </p>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>零售价</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span
              ><FmAmount
                :amount="editItem.relatedSaleOrderItem.buyingPrice"
              ></FmAmount
            ></span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>购买数量</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span>{{ editItem.relatedSaleOrderItem.itemQuantity }}</span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="16">
          <el-tooltip effect="dark" content="" placement="top-start">
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">出库进度说明</div>
              所对应销售单行项目的最新出库进度
            </div>
            <i class="el-icon el-icon-question fm-mr-5"></i>
          </el-tooltip>
          <span>销售单出库进度</span>
        </el-col>
        <el-col :span="8">
          <div class="quantity_info">
            <div class="column">
              <div class="title">
                <div>待出库</div>
                <div>出库中</div>
                <div>退货中</div>
              </div>
              <div class="num">
                <div>
                  {{ editItem.relatedSaleOrderItem.toBeOutputQuantity }}
                </div>
                <div>{{ editItem.relatedSaleOrderItem.outputingQuantity }}</div>
                <div>{{ editItem.relatedSaleOrderItem.returningQuantity }}</div>
              </div>
            </div>
            <div class="column" style="margin: 0 10px 0 10px">
              <div class="num">
                <div><br /></div>
                <div>,</div>
                <div>,</div>
              </div>
            </div>
            <div class="column">
              <div class="title">
                <div style="height: 19.2px"><br /></div>
                <div>已出库</div>
                <div>已退货</div>
              </div>
              <div class="num">
                <div><br /></div>
                <div>
                  {{ editItem.relatedSaleOrderItem.completedOutputQuantity }}
                </div>
                <div>
                  {{ editItem.relatedSaleOrderItem.completedReturnQuantity }}
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>总零售价</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span
              ><FmAmount
                :amount="
                  editItem.relatedSaleOrderItem.commodityBuyingTotalAmount
                "
              ></FmAmount
            ></span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>折扣金额</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span
              ><FmAmount
                :amount="editItem.relatedSaleOrderItem.disCountAmount"
              ></FmAmount
            ></span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>成交价</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span
              ><FmAmount
                :amount="editItem.relatedSaleOrderItem.itemAmount"
              ></FmAmount
            ></span>
          </p>
        </el-col>
      </el-row>

      <template v-if="from == 'SaleReturnOrder'">
        <el-divider></el-divider>
        <el-row class="fm-flex">
          <el-col :span="12">
            <span>退货数量</span>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <p>
              <span>
                <CommodityQuantityInputBox
                  v-model="editItem.itemQuantity"
                  label="数量"
                  size="small"
                  :min="0"
                  :max="editItem.relatedSaleOrderItem.itemQuantity"
                  @change="
                    (e) => {
                      changeItemQuantityFromList(
                        e,
                        selectList.findIndex(
                          (d) => d.itemNo == editItem.itemNo
                        ),
                        true
                      );
                    }
                  "
                ></CommodityQuantityInputBox>
              </span>
            </p>
          </el-col>
        </el-row>
      </template>

      <template v-if="from == 'CommodityOutputOrder'">
        <el-divider></el-divider>
        <el-row class="fm-flex">
          <el-col :span="12">
            <span>出库数量</span>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <p>
              <span>
                {{
                  editItem.itemQuantity > 0
                    ? "合计 " + editItem.itemQuantity
                    : "请选择仓库及填写出库数量"
                }}
                <!-- <el-input-number
                  v-model="nowQuantity"
                  label="数量"
                  size="small"
                  :precision="0"
                  :min="0"
                  :max="editItem.toBeOutputQuantity"
                  @change="
                    (e) => {
                      changeItemQuantityFromList(
                        e,
                        selectList.findIndex(
                          (d) => d.itemNo == editItem.itemNo
                        ),
                        true
                      );
                    }
                  "
                ></el-input-number> -->
              </span>
            </p>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-table
          :data="editItem.orderWareHouseAddNewPojoList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo;
            }
          "
          :key="'orderWareHouse' + orderWareHouseKey"
          style="width: 100%"
        >
          <el-table-column
            label="仓库"
            min-width="210"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <template
                v-if="
                  canSelectWareHouseListBySpec(
                    editItem.relatedSaleOrderItem.commoditySpec
                  ).length > 1
                "
              >
                <el-select
                  :value="scope.row.wareHouseId"
                  placeholder="请选择仓库"
                  @change="
                    (value) => selectWareHousePopupConfirm(value, scope.$index)
                  "
                >
                  <el-option
                    v-for="(item, index) in canSelectWareHouseListBySpec(
                      editItem.relatedSaleOrderItem.commoditySpec
                    )"
                    :key="item.wareHouseId + index"
                    :label="item.label"
                    :value="item.wareHouseId"
                  >
                    <span style="float: left">{{ item.wareHouse.name }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ "虚拟库存 " + item.fictitiousQuantity }}</span
                    >
                  </el-option>
                </el-select>
              </template>
              <div style="text-align: left" v-else>
                <span>{{ scope.row.wareHouse.name }}</span>
              </div>
              <div style="text-align: left">
                <span v-if="scope.row.wareHouse">
                  {{ "虚拟库存 " + scope.row.fictitiousQuantity }}
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="出库数量"
            min-width="190"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityQuantityInputBox
                v-model="scope.row.itemQuantity"
                size="small"
                :max="editItem.relatedSaleOrderItem.toBeOutputQuantity"
                style="width: 180px"
                @change="specWareHouseQuantityChange(scope.$index, scope.row)"
              ></CommodityQuantityInputBox>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            header-align="center"
            align="center"
            width="150"
            v-if="
              canSelectWareHouseListBySpec(
                editItem.relatedSaleOrderItem.commoditySpec
              ).length > 1
            "
          >
            <template slot-scope="scope">
              <el-button
                @click.native.stop="addSpecWareHouseItem(scope.$index)"
                type="text"
                icon="el-icon-plus"
                :disabled="
                  editItem.orderWareHouseAddNewPojoList.length ==
                  canSelectWareHouseListBySpec(
                    editItem.relatedSaleOrderItem.commoditySpec
                  ).length
                "
              >
                增加
              </el-button>
              <el-button
                type="text"
                icon="el-icon-delete"
                v-fmtype="
                  editItem.orderWareHouseAddNewPojoList.length == 1
                    ? 'info'
                    : 'error'
                "
                :disabled="editItem.orderWareHouseAddNewPojoList.length == 1"
                @click.native.stop="deleteSpecWareHouseItem(scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-divider></el-divider>

        <el-row class="fm-flex">
          <el-col :span="12">
            <span>配送费</span>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <p>
              <span>
                <el-input-number
                  style="width: 170px"
                  v-model="editItem.distributionPrice"
                  label="配送费"
                  size="small"
                  :precision="2"
                  :min="0"
                  :step="1"
                ></el-input-number>
              </span>
            </p>
          </el-col>
        </el-row>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editItemCancel">取 消</el-button>
        <el-button type="primary" @click="editItemConfirm"> 选 择 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebSaleOrderItemSelectDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    from: {
      // 来源，SaleReturnOrder 销售退货单 | CommodityOutputOrder 出库单
      type: String,
      default: null,
      require: true,
    },
    customerId: {
      type: String,
      default: null,
      require: true,
    },
    saleOrderId: {
      type: String,
      default: null,
      require: true,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    show: {
      handler(newVal) {
        this.orderWareHouseKey = this.$options.data().orderWareHouseKey;
        this.getOrderInfo();
        this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
      },
      immediate: true,
    },
  },
  data() {
    return {
      //   saleOrderId: null,
      loading: false,

      editItemPopupShow: false,
      // 当前选择的item
      editItem: {},

      // 显示已选商品弹窗
      showSelectListPopup: false,
      // 已选的商品 成型数据
      //   selectList: [],

      headInfo: {
        orderApprovalStatusEnum: {},
        orderDate: null,
        customerId: null,
        customerName: null,
        customerPhoneNumber: null,
        customerAddress: "",
        saleUserIdList: [],
        relatedPreCollectOrderIdList: [],
        commodityBuyingTotalAmount: "0.00",
        disCountAmount: "0.00",
        orderAmount: "0.00",
        totalQuantity: 0,
      },
      itemList: [],

      selectWareHousePopupShow: false,
      orderWareHouseKey: "null",
      selectWareHousePopupIndex: -1,
      wareHouseList: [],

      quantityMinLimit: 0.001,
    };
  },
  methods: {
    canSelectWareHouseListBySpec(commoditySpec) {
      let res = commoditySpec.commoditySpecWareHouseList.map((d) => {
        return {
          label: d.wareHouse.name,
          wareHouse: d.wareHouse,
          wareHouseId: d.wareHouseId,
          fictitiousQuantity: d.fictitiousQuantity,
          availableQuantity: d.availableQuantity,
          desc: "虚拟库存 " + d.fictitiousQuantity,
        };
      });
      return res;
    },

    // 选择仓库
    showSelectWareHousePopup(index) {
      this.wareHouseList = this.canSelectWareHouseListBySpec(
        this.editItem.relatedSaleOrderItem.commoditySpec
      );
      this.orderWareHouseKey = Math.random();
      this.selectWareHousePopupIndex = index;
      this.selectWareHousePopupShow = true;
    },
    selectWareHousePopupConfirm(item, selectWareHousePopupIndex) {
      if (item) {
        let selectIndex = this.editItem.orderWareHouseAddNewPojoList.findIndex(
          (d) => d.wareHouseId && d.wareHouseId == item
        );
        if (selectIndex > -1) {
          this.$message.error("请勿重复选择仓库");
          this.selectWareHousePopupShow = false;
          return;
        }
        let data = this.canSelectWareHouseListBySpec(
          this.editItem.relatedSaleOrderItem.commoditySpec
        ).filter((d) => d.wareHouseId && d.wareHouseId == item)[0];
        this.editItem.orderWareHouseAddNewPojoList.splice(
          selectWareHousePopupIndex,
          1,
          {
            ...this.editItem.orderWareHouseAddNewPojoList[
              selectWareHousePopupIndex
            ],
            wareHouse: data.wareHouse,
            wareHouseId: data.wareHouseId,
            fictitiousQuantity: data.fictitiousQuantity,
            availableQuantity: data.availableQuantity,
          }
        );
        this.orderWareHouseKey = Math.random();
        this.selectWareHousePopupShow = false;
      }
    },
    specWareHouseQuantityChange() {
      let quantity = Number(
        this.$jsTool.sumQuantity(
          this.editItem.orderWareHouseAddNewPojoList.map(
            (d) => d.itemQuantity || 0
          )
        )
      );
      this.editItem.itemQuantity = quantity;
      this.editItem.distributionPrice = this.$jsTool.multi(
        this.editItem.relatedSaleOrderItem.commoditySpecSnapshot
          .distributionPrice,
        quantity
      );
    },
    addSpecWareHouseItem(index) {
      this.editItem.orderWareHouseAddNewPojoList.splice(index + 1, 0, {
        itemNo:
          this.editItem.orderWareHouseAddNewPojoList[
            this.editItem.orderWareHouseAddNewPojoList.length - 1
          ].itemNo + 1,
        itemQuantity: 1,
      });
      this.orderWareHouseKey = Math.random();
      this.specWareHouseQuantityChange();
    },
    deleteSpecWareHouseItem(index) {
      let that = this;
      this.$confirm("确认删除所选仓库信息？", "操作提醒", {
        confirmButtonText: "继续删除",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
      })
        .then(() => {
          that.editItem.orderWareHouseAddNewPojoList.splice(index, 1);
          this.orderWareHouseKey = Math.random();
          that.specWareHouseQuantityChange();
        })
        .catch(() => {});
    },
    showEditSpecPopup(item, index) {
      if (!this.from == "CommodityOutputOrder") {
        return;
      }
      this.editItem = JSON.parse(JSON.stringify(item));
      this.editItemPopupShow = true;
    },

    close() {
      this.$emit("close");
    },
    async select(item) {
      // SaleReturnOrder 销售退货单 | CommodityOutputOrder 出库单
      if (this.from == "SaleReturnOrder") {
        if (
          item.itemQuantity ==
          item.returningQuantity + item.completedReturnQuantity
        ) {
          this.$message({
            message: "所选销售单行项目可退货数量为 0 ，请选择其他行项目",
            type: "error",
          });
          return;
        }
      } else if (this.from == "CommodityOutputOrder") {
        if (item.toBeOutputQuantity == 0) {
          this.$message({
            message: "所选销售单行项目待出库数量为 0 ，请选择其他行项目",
            type: "error",
          });
          return;
        }
      }

      let index =
        this.from == "SaleReturnOrder"
          ? this.selectList.findIndex(
              (d) => d.relatedSaleOrderItemId == item.id
            )
          : this.selectList.findIndex((d) => d.relatedOrderItemId == item.id);
      if (index > -1) {
        this.editItem = JSON.parse(JSON.stringify(this.selectList[index]));
        if (this.from == "CommodityOutputOrder") {
          if (this.selectList[index].distributionPrice) {
            this.editItem.distributionPrice =
              this.selectList[index].distributionPrice;
          } else {
            this.editItem.distributionPrice =
              this.selectList[index].relatedSaleOrderItem.commoditySpecSnapshot
                .distributionPrice || "0.00";
          }
        }
      } else {
        let itemNo =
          this.selectList && this.selectList.length > 0
            ? this.selectList[this.selectList.length - 1].itemNo + 1
            : 1;
        this.editItem = {
          itemNo: itemNo,
          relatedOrderItemId: item.id,
          relatedSaleOrderItem: item,
          relatedSaleOrderItemId: item.id,
          itemQuantity: 1,
          distributionPrice: "0.00",
          commodityBuyingTotalAmount: this.$jsTool.multi(item.buyingPrice, 1),
          orderWareHouseAddNewPojoList: [
            {
              itemNo: 1,
              itemQuantity: 1,
            },
          ],
        };

        // 获取商品信息
        let getCommoditySpecRes = await this.$api.commoditySpec_findById(
          item.commoditySpecId
        );
        if (getCommoditySpecRes && getCommoditySpecRes.success) {
          this.editItem.relatedSaleOrderItem.commoditySpec =
            getCommoditySpecRes.data;
        }
        if (this.from == "CommodityOutputOrder") {
          this.editItem.distributionPrice =
            item.commoditySpecSnapshot.distributionPrice || "0.00";
          // 只有一个则默认选择
          let canSelectWareHouseListBySpec = this.canSelectWareHouseListBySpec(
            this.editItem.relatedSaleOrderItem.commoditySpec
          );
          let specWareHouse =
            canSelectWareHouseListBySpec.length == 1
              ? canSelectWareHouseListBySpec[0]
              : {};
          this.editItem.orderWareHouseAddNewPojoList = [
            {
              itemNo: 1,
              wareHouse: specWareHouse.wareHouse || null,
              wareHouseId: specWareHouse.wareHouseId || null,
              fictitiousQuantity: specWareHouse.fictitiousQuantity || 0,
              availableQuantity: specWareHouse.availableQuantity || 0,
              itemQuantity: 1,
            },
          ];
        }
      }
      this.editItemPopupShow = true;
    },
    editItemCancel() {
      this.editItemPopupShow = false;
      this.editItem = {};
    },
    editItemConfirm() {
      if (!this.editItem || !this.editItem.itemNo) {
        this.$message({
          message: "请选择商品",
          type: "error",
        });
        return;
      }
      if (!this.editItem.itemQuantity) {
        this.$message({
          message: "请输入数量",
          type: "error",
        });
        return;
      }
      this.loading = true;
      try {
        let index =
          this.from == "SaleReturnOrder"
            ? this.selectList.findIndex(
                (d) =>
                  d.relatedSaleOrderItemId ==
                  this.editItem.relatedSaleOrderItemId
              )
            : this.selectList.findIndex(
                (d) => d.relatedOrderItemId == this.editItem.relatedOrderItemId
              );
        // let itemNo =
        //   index > -1
        //     ? this.selectList[index].itemNo
        //     : this.selectList && this.selectList.length > 0
        //     ? this.selectList[this.selectList.length - 1].itemNo + 1
        //     : 1;
        let itemAmount = this.$jsTool.multi(
          this.editItem.relatedSaleOrderItem.buyingPrice,
          this.editItem.itemQuantity
        );
        // let item = {
        //   itemNo: itemNo,
        //   relatedOrderItemId: this.editItem.id,
        //   relatedSaleOrderItem: this.editItem,
        //   relatedSaleOrderItemId: this.editItem.id,
        //   itemQuantity: this.nowQuantity,
        //   distributionPrice: this.nowDistributionPrice,
        //   commodityBuyingTotalAmount: itemAmount,
        // };
        let item = {
          ...this.editItem,
          commodityBuyingTotalAmount: itemAmount,
        };
        if (this.from == "CommodityOutputOrder") {
          item.orderWareHouseAddNewPojoList =
            this.editItem.orderWareHouseAddNewPojoList;
          if (
            this.editItem.orderWareHouseAddNewPojoList.some(
              (item) => !item.wareHouseId
            )
          ) {
            this.$message({
              message: "请选择仓库后重试！",
              type: "error",
            });
            return;
          }
          let quantity = Number(
            this.$jsTool.sumQuantity(
              this.editItem.orderWareHouseAddNewPojoList.map(
                (d) => d.itemQuantity || 0
              )
            )
          );
          if (
            quantity > this.editItem.relatedSaleOrderItem.toBeOutputQuantity
          ) {
            this.$message({
              message:
                "出库总数量不得大于所选商品的待出库数量" +
                this.editItem.relatedSaleOrderItem.toBeOutputQuantity,
              type: "error",
            });
            return;
          }
        }
        if (index > -1) {
          this.selectList.splice(index, 1, item);
        } else {
          this.selectList.push(item);
        }
        this.editItemPopupShow = false;
        this.$emit("selectSaleOrderItem", this.selectList || []);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (!this.editItemPopupShow) {
          this.$emit("close");
        }
      }
    },

    changeItemQuantityFromList(value, index) {
      if (this.from == "CommodityOutputOrder") {
        this.editItem.distributionPrice = this.$jsTool.multi(
          this.editItem.relatedSaleOrderItem.commoditySpecSnapshot
            .distributionPrice,
          value
        );
      }
      // 如果index < 0，则代表是新商品，无需进行处理
      if (index < 0) {
        return;
      }
      if (value <= 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            try {
              this.editItem = {};
              this.selectList.splice(index, 1);
              this.editItemPopupShow = false;
              this.$emit("selectSaleOrderItem", this.selectList || []);
            } finally {
              if (!this.editItemPopupShow) {
                this.$emit("close");
              }
            }
          })
          .catch(() => {
            this.editItem.itemQuantity = this.quantityMinLimit;
          });
      }
    },
    // changeItemQuantityFromSeeMore(value, index) {
    //   if (value <= 0) {
    //     let that = this;
    //     this.$showModal({
    //       title: "操作提醒",
    //       content: "是否移除所选商品?",
    //       confirmText: "移除",
    //       confirmColor: "error",
    //       success: (res) => {
    //         if (res.confirm) {
    //           that.selectList.splice(index, 1);
    //         } else {
    //           that.selectList[index].itemQuantity = 1;
    //           that.$refs.quantityBox[index].init();
    //           that.$forceUpdate();
    //         }
    //       },
    //     });
    //   } else {
    //     let commoditySpec =
    //       this.selectList[index].relatedSaleOrderItem.commoditySpecSnapshot;
    //     let buyingPrice =
    //       this.selectList[index].relatedSaleOrderItem.buyingPrice;
    //     let itemAmount = this.$tool.multi(buyingPrice, value);
    //     let distributionPrice = this.$tool.multi(
    //       this.selectList[index].relatedSaleOrderItem.commoditySpecSnapshot
    //         .distributionPrice,
    //       value
    //     );
    //     let item = {
    //       ...this.selectList[index],
    //       distributionPrice: distributionPrice,
    //       itemQuantity: value,
    //       commodityBuyingTotalAmount: itemAmount,
    //     };
    //     this.selectList.splice(index, 1, item);
    //   }
    // },
    // // 确认选择
    // confirmSelect() {
    //   let that = this;
    //   this.$confirm(
    //     !that.selectList || that.selectList.length == 0
    //       ? "尚未选择商品，继续确认将会移除单据中原已选择的商品，是否继续？"
    //       : "是否选择完成？",
    //     "操作提醒",
    //     {
    //       confirmButtonText:
    //         !that.selectList || that.selectList.length == 0
    //           ? "继续确认"
    //           : "选择完成",
    //       closeOnClickModal: false,
    //       closeOnPressEscape: false,
    //       closeOnHashChange: false,
    //     }
    //   ).then((action) => {
    //     try {
    //       console.log("action", action);
    //       this.$emit("selectSaleOrderItem", that.selectList || []);
    //     } finally {
    //     }
    //   });
    // },
    async getOrderInfo(args) {
      this.loading = true;
      let res = await this.$api.saleOrder_findVoById(this.saleOrderId, args);
      if (res && res.success) {
        this.headInfo = {
          ...res.data.headVo,
          saleUserIdList: res.data.headVo.saleUserList.map((d) => d.userId),
          relatedPreCollectOrderIdList:
            res.data.headVo.relatedPreCollectOrderList.map(
              (d) => d.preCollectOrderId
            ),
        };
        this.itemList = res.data.itemList;
      }
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
/* 解决分割线存在粗细不一致异常 */
.el-divider {
  background-color: transparent;
  position: relative;
}

.el-divider--horizontal {
  height: 0;
  border-bottom: 1px solid #dcdfe6;
}
</style>


// WEBPACK FOOTER //
// src/components/SaleOrderItemSelectDialog.vue